import { render, staticRenderFns } from "./TablaEsteroides.vue?vue&type=template&id=2ee98e64"
import script from "./TablaEsteroides.vue?vue&type=script&lang=js"
export * from "./TablaEsteroides.vue?vue&type=script&lang=js"
import style0 from "./TablaEsteroides.vue?vue&type=style&index=0&id=2ee98e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports